import { DPE_COLORS } from '@/config';

interface PopupInfoProps {
  properties: Record<string, unknown>;
  layer: string;
}

const LABELS: Record<string, string> = {
  nature: 'Nature',
  height: 'Hauteur',
  nb_floors: 'Étages',
  dpe_label: 'DPE',
  energy_kwh_m2: 'Énergie',
  surface_m2: 'Surface',
  name: 'Nom',
  width: 'Largeur',
  category: 'Catégorie',
  cadastre_id: 'Réf. cadastrale',
  price_per_m2: 'Prix/m²',
  code_insee: 'Code INSEE',
  population: 'Population',
};

const UNITS: Record<string, string> = {
  height: 'm',
  energy_kwh_m2: 'kWh/m²/an',
  surface_m2: 'm²',
  width: 'm',
  price_per_m2: '€/m²',
};

export function PopupInfo({ properties, layer }: PopupInfoProps) {
  const entries = Object.entries(properties).filter(
    ([key]) => key !== 'id' && key !== 'bdtopo_id' && LABELS[key],
  );

  return (
    <div className="min-w-[200px]">
      <p className="mb-2 border-b pb-1 text-xs font-semibold uppercase text-gray-500">
        {layer.includes('building') && 'Bâtiment'}
        {layer.includes('road') && 'Voirie'}
        {layer.includes('facilit') && 'Équipement'}
        {layer.includes('parcel') && 'Parcelle'}
        {layer.includes('territor') && 'Territoire'}
      </p>

      <div className="space-y-1">
        {entries.map(([key, value]) => {
          if (value === null || value === undefined || value === '') return null;

          return (
            <div key={key} className="flex items-center justify-between gap-4">
              <span className="text-xs text-gray-500">{LABELS[key] || key}</span>
              <span className="text-xs font-medium text-gray-800">
                {key === 'dpe_label' ? (
                  <span
                    className="inline-flex h-5 w-5 items-center justify-center rounded text-xs font-bold text-white"
                    style={{ backgroundColor: DPE_COLORS[String(value)] || '#999' }}
                  >
                    {String(value)}
                  </span>
                ) : (
                  <>
                    {typeof value === 'number' ? value.toLocaleString('fr-FR') : String(value)}
                    {UNITS[key] ? ` ${UNITS[key]}` : ''}
                  </>
                )}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
